import Panel from '../components/panel'
import {Button} from '../components//button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";
import { MEASURE_WIDGET_DACH } from "../state/measures.tsx";
import { MODAL_CONFIRM_BUTTON_LABEL } from "../config.ts";
import GEGInfo from "../components/geg_info.tsx";
import { round_to_1000 } from "../functions.ts";
import { useEffect } from "react";

export default function ModalDachFuture() {
    const pop_modal = useStore((state)=>state.pop_modal);
    const close_menu = useStore((state) => state.close_menu);
    const api_recalculate = useStore((state) => state.api_recalculate);
    const init_property_if_undefined = useStore((state) => state.init_property_if_undefined);
    const financial_plan_dummy = useStore((state)=>state.financial_plan_dummy);    

    const dach_future = useStore((state)=>state.dach_future);    
    const api_get_costs = useStore((state)=>state.api_get_costs);
    useEffect(()=>{
        api_get_costs("roof_insulation",dach_future);
    },[dach_future]);

  return (<Panel >
            <h1>Welche neue Dachdämmung ist geplant?</h1>
            <GEGInfo GEG={0.2} BEG={0.14}/>
            <PropertyInput type="dach_future"/>
            <PropertyInput type="dach_kosten"  placeholder_prefix={"optional ca."} placeholder_override={round_to_1000(financial_plan_dummy["roof_insulation"].total_costs)  + " €"} />
            <PropertyInput type="dach_isfp"/>
            <Button label={MODAL_CONFIRM_BUTTON_LABEL} onClick={()=>{
                close_menu();
                init_property_if_undefined("dach_future");
                api_recalculate();
                pop_modal();
            }}/>
         </Panel>)
}

